import React from 'react';

export const SelectModalActionBar = ({totalSelected, onCancel, onSave, hideActions}) => {
    return (
        <div className="flex items-center justify-between px-4 py-2 border-t border-panels-normal">
            <span className="text-sm text-main-disabled cursor-default">{totalSelected} selected</span>
            {!hideActions && (
                <div className="flex items-center gap-2">
                    <button
                        data-testid="select-modal-cancel"
                        className="text-sm text-main-normal px-3 py-1.5 rounded-button hover:bg-windowsandmenus-hover"
                        onClick={onCancel}
                    >
                        Cancel
                    </button>
                    <button
                        data-testid="select-modal-save"
                        className="text-sm text-white px-3 py-1.5 rounded-button bg-classic-button-normal hover:bg-classic-button-hover"
                        onClick={onSave}
                    >
                        Save Changes
                    </button>
                </div>
            )}
        </div>
    );
};
